module.exports = __webpack_public_path__ + "img/group-logo-white.8627e2f7.svg";